function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useMemo } from 'react';
import defaultIcon from "../square/default.svg";
import { Menu, Space, Dropdown, Image } from 'antd';
import { ArrowDownOutlined } from 'iglooicon';
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SwitchPlatform = function SwitchPlatform(_ref) {
  var platforms = _ref.platforms,
    currentPlatform = _ref.currentPlatform,
    onChange = _ref.onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showDefault = _useState2[0],
    setShowDefault = _useState2[1];
  var handleChange = function handleChange(e) {
    setShowDefault(false);
    onChange(e.key);
  };
  var currentName = useMemo(function () {
    var name = currentPlatform;
    var _iterator = _createForOfIteratorHelper(platforms),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _platform = _step.value;
        if (typeof _platform === 'string') {
          break;
        }
        if (_platform.key === currentPlatform) {
          name = _platform.name;
          break;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return name;
  }, [platforms, currentPlatform]);
  return /*#__PURE__*/_jsx(Dropdown, {
    className: "igloo-switch-platform",
    trigger: ['click'],
    overlay: /*#__PURE__*/_jsx(Menu, {
      onClick: handleChange,
      children: platforms === null || platforms === void 0 ? void 0 : platforms.map(function (platform) {
        var name = typeof platform === 'string' ? platform : platform.name;
        var key = typeof platform === 'string' ? platform : platform.key;
        return /*#__PURE__*/_jsxs(Menu.Item, {
          className: "igloo-switch-platform-option",
          children: [/*#__PURE__*/_jsx(Image, {
            src: "https://static.iglooinsure.com/partner/square/".concat(key.toLowerCase(), ".svg"),
            className: "igloo-switch-platform-default-logo",
            fallback: defaultIcon,
            preview: false
          }), /*#__PURE__*/_jsx("span", {
            className: "igloo-switch-platform-name",
            children: name
          })]
        }, key);
      })
    }),
    getPopupContainer: function getPopupContainer(trigger) {
      return trigger.parentElement;
    },
    placement: "bottom",
    children: /*#__PURE__*/_jsxs(Space, {
      size: 8,
      align: "center",
      children: [/*#__PURE__*/_jsx("div", {
        className: "igloo-switch-platform-nav",
        children: !showDefault ? /*#__PURE__*/_jsx(Image, {
          src: "https://static.iglooinsure.com/partner/nav/".concat(currentPlatform.toLowerCase(), ".svg"),
          className: "igloo-switch-platform-nav-logo",
          onError: function onError() {
            return setShowDefault(true);
          },
          preview: false
        }) : /*#__PURE__*/_jsxs(Space, {
          size: 8,
          align: "center",
          children: [/*#__PURE__*/_jsx("img", {
            src: defaultIcon,
            className: "igloo-switch-platform-default-logo"
          }), /*#__PURE__*/_jsx("span", {
            className: "igloo-switch-platform-name",
            children: currentName
          })]
        })
      }), /*#__PURE__*/_jsx(ArrowDownOutlined, {
        className: "igloo-switch-platform-arrow"
      })]
    })
  });
};
export default SwitchPlatform;